"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FastapiKrakenEndpointsStatsModelsGetPropertiesResponsesStatsLatestEstimate$ = exports.FastapiKrakenEndpointsStatsModelsGetPropertiesResponsesStatsLatestEstimate$outboundSchema = exports.FastapiKrakenEndpointsStatsModelsGetPropertiesResponsesStatsLatestEstimate$inboundSchema = void 0;
exports.fastapiKrakenEndpointsStatsModelsGetPropertiesResponsesStatsLatestEstimateToJSON = fastapiKrakenEndpointsStatsModelsGetPropertiesResponsesStatsLatestEstimateToJSON;
exports.fastapiKrakenEndpointsStatsModelsGetPropertiesResponsesStatsLatestEstimateFromJSON = fastapiKrakenEndpointsStatsModelsGetPropertiesResponsesStatsLatestEstimateFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
/** @internal */
exports.FastapiKrakenEndpointsStatsModelsGetPropertiesResponsesStatsLatestEstimate$inboundSchema = z.object({
    value: z.number().int(),
    value_rounded: z.number().int(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "value_rounded": "valueRounded",
    });
});
/** @internal */
exports.FastapiKrakenEndpointsStatsModelsGetPropertiesResponsesStatsLatestEstimate$outboundSchema = z.object({
    value: z.number().int(),
    valueRounded: z.number().int(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        valueRounded: "value_rounded",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var FastapiKrakenEndpointsStatsModelsGetPropertiesResponsesStatsLatestEstimate$;
(function (FastapiKrakenEndpointsStatsModelsGetPropertiesResponsesStatsLatestEstimate$) {
    /** @deprecated use `FastapiKrakenEndpointsStatsModelsGetPropertiesResponsesStatsLatestEstimate$inboundSchema` instead. */
    FastapiKrakenEndpointsStatsModelsGetPropertiesResponsesStatsLatestEstimate$.inboundSchema = exports.FastapiKrakenEndpointsStatsModelsGetPropertiesResponsesStatsLatestEstimate$inboundSchema;
    /** @deprecated use `FastapiKrakenEndpointsStatsModelsGetPropertiesResponsesStatsLatestEstimate$outboundSchema` instead. */
    FastapiKrakenEndpointsStatsModelsGetPropertiesResponsesStatsLatestEstimate$.outboundSchema = exports.FastapiKrakenEndpointsStatsModelsGetPropertiesResponsesStatsLatestEstimate$outboundSchema;
})(FastapiKrakenEndpointsStatsModelsGetPropertiesResponsesStatsLatestEstimate$ || (exports.FastapiKrakenEndpointsStatsModelsGetPropertiesResponsesStatsLatestEstimate$ = FastapiKrakenEndpointsStatsModelsGetPropertiesResponsesStatsLatestEstimate$ = {}));
function fastapiKrakenEndpointsStatsModelsGetPropertiesResponsesStatsLatestEstimateToJSON(fastapiKrakenEndpointsStatsModelsGetPropertiesResponsesStatsLatestEstimate) {
    return JSON.stringify(exports.FastapiKrakenEndpointsStatsModelsGetPropertiesResponsesStatsLatestEstimate$outboundSchema
        .parse(fastapiKrakenEndpointsStatsModelsGetPropertiesResponsesStatsLatestEstimate));
}
function fastapiKrakenEndpointsStatsModelsGetPropertiesResponsesStatsLatestEstimateFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.FastapiKrakenEndpointsStatsModelsGetPropertiesResponsesStatsLatestEstimate$inboundSchema
        .parse(JSON.parse(x)), `Failed to parse 'FastapiKrakenEndpointsStatsModelsGetPropertiesResponsesStatsLatestEstimate' from JSON`);
}
//# sourceMappingURL=fastapikrakenendpointsstatsmodelsgetpropertiesresponsesstatslatestestimate.js.map